export default {"src":"/_next/static/media/financial-statement-hero-bg.89f40ec7.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};